import { render, staticRenderFns } from "./SystemPermissionTreeView.vue?vue&type=template&id=10be0657&scoped=true"
import script from "./SystemPermissionTreeView.vue?vue&type=script&lang=js"
export * from "./SystemPermissionTreeView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10be0657",
  null
  
)

export default component.exports